import { Model } from 'shared/services/api/models/Model'

export interface ThreadAttachmentResponseV1 {
  type: string
  data: string
}

export class ThreadAttachmentResponse extends Model {
  public readonly type: string
  public readonly data: string

  constructor(src: ThreadAttachmentResponseV1) {
    super(src)
    this.type = src.type
    this.data = src.data
  }
}
